export const CONTACT = {
    phoneDisplay: "06 52 36 02 71",
    phoneHref: "tel:+33652360271",
    whatsapp: "https://wa.me/33652360271",
    email: "contact@cleanmylife.fr",
    site: "cleanmylife.fr",
};

export const FORMULAS = [
    {
        id: "fresh",
        name: "CML FRESH",
        price: "70 €",
        img: "/brand/fresh.webp",
        tag: "L'ESSENTIEL",
        includes: null,
        features: [
            "Lavage extérieur",
            "Jantes & pneus",
            "Vitres intérieures / extérieures",
            "Aspirateur habitacle & coffre",
            "Dépoussiérage intérieur",
            "Seuils & contours de portes",
            "Finition fraîche & propre",
        ],
        cta: "RÉSERVER",
        popular: false,
    },
    {
        id: "full",
        name: "CML FULL",
        price: "120 €",
        img: "/brand/full.webp",
        tag: "NETTOYAGE COMPLET",
        includes: "Comprend FRESH +",
        features: [
            "Nettoyage intérieur complet",
            "Plastiques & surfaces en profondeur",
            "Coffre détaillé",
            "Dressing pneus",
            "Nettoyage vapeur zones sensibles",
            "Nettoyage tissus / cuir / Alcantara",
            "Finition premium",
        ],
        cta: "RÉSERVER",
        popular: true,
    },
    {
        id: "revive",
        name: "CML REVIVE",
        price: "160 €",
        img: "/brand/revive.webp",
        tag: "REMISE EN ÉTAT",
        includes: "Comprend FRESH + FULL +",
        features: [
            "Shampouinage sièges, tapis & moquettes",
            "Détachage ciblé",
            "Nettoyage, soin & protection cuir / Alcantara",
            "Nettoyage en profondeur des textiles",
            "Remise en état intérieur poussée",
            "Finition en profondeur",
        ],
        cta: "RÉSERVER",
        popular: false,
    },
];

export const WHY_ITEMS = [
    {
        icon: "Home",
        title: "Service à domicile",
        desc: "Votre véhicule est entretenu directement sur le lieu convenu.",
    },
    {
        icon: "Gem",
        title: "Résultat premium",
        desc: "Une attention particulière portée aux détails et à la finition.",
    },
    {
        icon: "FlaskConical",
        title: "Produits professionnels",
        desc: "Matériel et produits adaptés au nettoyage et au detailing automobile.",
    },
    {
        icon: "MapPin",
        title: "Cannes & alentours",
        desc: "Un service mobile pensé pour la Côte d'Azur.",
    },
];

export const STEPS = [
    {
        num: "01",
        title: "Choisissez votre formule",
        desc: "FRESH, FULL ou REVIVE.",
    },
    {
        num: "02",
        title: "Choisissez votre créneau",
        desc: "Sélection d'une date et d'une heure disponibles.",
    },
    {
        num: "03",
        title: "Indiquez votre véhicule et votre adresse",
        desc: "Coordonnées, lieu d'intervention, marque et modèle.",
    },
    {
        num: "04",
        title: "Clean My Life vient à vous",
        desc: "Nous nous déplaçons directement sur le lieu convenu.",
    },
];

export const STORY_TEXT =
    "Clean My Life est né d'une passion pour l'automobile et de plusieurs années d'expérience dans l'hôtellerie de luxe en tant que voiturier. Être quotidiennement au contact de véhicules haut de gamme et de clients exigeants a donné naissance à l'idée de proposer un service automobile à domicile associant soin du véhicule, confort et qualité de service.";

export const NAV_LINKS = [
    { label: "Accueil", hash: "#accueil" },
    { label: "Formules", hash: "#formules" },
    { label: "Avant / Après", hash: "#avant-apres" },
    { label: "À propos", hash: "#a-propos" },
    { label: "Contact", hash: "#contact" },
];

export const TIME_SLOTS = ["08:00", "09:30", "11:00", "13:00", "14:30", "16:00", "17:30"];

export const VEHICLE_TYPES = ["Citadine", "Berline", "SUV / 4x4", "Utilitaire / Van", "Coupé / Cabriolet"];
